import React from 'react';
import { Treemap } from '@visx/hierarchy';
import {
  QUESTION_AREA_BORDER,
  QUESTION_AREA_RADIUS,
  QUESTION_TILE_GAP,
  scoreFill,
} from './rubricTreemapUtils';

export default function QuestionNodes({
  questionAreaX,
  questionAreaY,
  questionAreaWidth,
  questionAreaHeight,
  questionRoot,
  name,
  onQuestionHover,
  onQuestionLeave,
}) {
  const hasQuestionNodes = questionRoot.children?.length > 0;
  if (!hasQuestionNodes || questionAreaWidth <= 0 || questionAreaHeight <= 0) {
    return null;
  }

  return (
    <g transform={`translate(${questionAreaX}, ${questionAreaY})`}>
      <rect
        x={0}
        y={0}
        width={questionAreaWidth}
        height={questionAreaHeight}
        fill={QUESTION_AREA_BORDER}
        stroke="none"
        rx={QUESTION_AREA_RADIUS}
      />
      <Treemap
        root={questionRoot}
        size={[questionAreaWidth, questionAreaHeight]}
        padding={QUESTION_TILE_GAP}
        round
      >
        {(questionTreemap) => (
          <g>
            {questionTreemap
              .descendants()
              .filter((questionNode) => !questionNode.children)
              .map((questionNode) => {
                const questionWidth = Math.max(
                  0,
                  questionNode.x1 - questionNode.x0
                );
                const questionHeight = Math.max(
                  0,
                  questionNode.y1 - questionNode.y0
                );
                return (
                  <rect
                    key={
                      questionNode.data.id ||
                      questionNode.data.key ||
                      `${name}-${questionNode.x0}-${questionNode.y0}`
                    }
                    x={questionNode.x0}
                    y={questionNode.y0}
                    width={questionWidth}
                    height={questionHeight}
                    fill={scoreFill(questionNode.data.score)}
                    opacity={0.9}
                    stroke="none"
                    rx={2}
                    onMouseMove={(event) =>
                      onQuestionHover(event, questionNode.data)
                    }
                    onMouseLeave={onQuestionLeave}
                  />
                );
              })}
          </g>
        )}
      </Treemap>
    </g>
  );
}
